<template>
  <public-page>
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" lg="6" md="8" sm="12">
        <v-card elevation="4">
          <v-toolbar color="indigo" dark>
            <v-toolbar-title>Password Reset</v-toolbar-title>
          </v-toolbar>

          <div v-if="!emailSent">
            <v-card-text>
              <p>Type the email you used to register:</p>
              <v-alert v-if="error" type="error">
                {{ error }}
              </v-alert>
              <v-form
                lazy-validation
                v-model="valid"
                id="form"
                ref="form"
                action="POST"
                @submit.prevent="resetPassword"
              >
                <v-container class="text-center">
                  <v-text-field
                    label="Email"
                    :min="0"
                    :counter="50"
                    v-model="email"
                    :rules="emailRules"
                  ></v-text-field>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                form="form"
                @click="validate"
                color="primary"
                :disabled="!valid"
              >
                Reset Password
              </v-btn>
            </v-card-actions>
          </div>
          <div v-else>
            <v-card-text>
              <p>
                If the email you entered is registered, you will receive an
                email with a link to reset your password.
              </p>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </public-page>
</template>

<script>
import { API } from "@/axios-config";
import PublicPage from "@/components/PublicPage";

export default {
  name: "PasswordResetEmail",
  components: {
    PublicPage,
  },
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      valid: false,
      error: null,
      emailSent: false,
    };
  },
  methods: {
    async resetPassword() {
      try {
        await API.post("/api/v1/accounts/password/reset/email/", {
          email: this.email,
        });
        this.emailSent = true;
      } catch (error) {
        console.log(error);
      }
    },

    validate() {
      this.error = null;
      this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.v-btn,
.v-card {
  border-radius: 4px;
}
.v-card__title {
  text-transform: uppercase;
}
</style>